import { FC } from "react";
import { useTrans } from "../../../hooks";
import { Text, HStack } from "@chakra-ui/react";
import {
    DataType,
    IKaTableProps,
    ITableInstance,
    Table as KaTable,
    SortingMode,
} from "ka-table";
import { Column, PagingOptions } from "ka-table/models";
import { ICellTextProps } from "ka-table/props";
import {
    AppOptionBoxItem,
    AppOptionsBox,
    KaPageSizeSelector,
} from "../../../components";

export const TypologyList: FC<{
    table: ITableInstance;
    paging: PagingOptions;
    list: any[];
    loadingList?: boolean;
    onActionClick?: (key: string, data?: any) => void;
}> = ({
    table,
    paging,
    list,
    loadingList = false,
    onActionClick = () => {},
}) => {
    const { t } = useTrans();
    const columns: Column[] = [
        {
            key: "name",
            title: t("ent.Typology:name.label"),
            dataType: DataType.String,
        },
        {
            key: "training",
            title: t("ent.Typology:training.label"),
            dataType: DataType.Object,
            isSortable: false,
        },
        {
            key: "action",
            title: "",
            style: { textAlign: "right" },
            dataType: DataType.Object,
            width: 50,
            isSortable: false,
        },
    ];

    const actionOptions: AppOptionBoxItem[] = [
        {
            key: "edit",
            label: t("cmn:option.edit"),
            iconName: "icl-pencil",
        },
        {
            key: "delete",
            label: t("cmn:option.delete"),
            iconName: "icl-trash",
        },
    ];

    const kaTableProps: IKaTableProps = {
        table: table,
        columns: columns,
        data: list || [],
        loading: {
            enabled: loadingList,
        },
        paging: paging,
        rowKeyField: "id",
        sortingMode: SortingMode.SingleRemote,
        childComponents: {
            pagingSizes: {
                content: (props) => <KaPageSizeSelector {...props} />,
            },
            cellText: {
                content: (props: ICellTextProps) => {
                    switch (props?.column?.key) {
                        case "name":
                            return (
                                <Text
                                    textStyle={"mediumSm"}
                                    color={"var(--chakra-colors-black)"}
                                >
                                    {props?.rowData?.name}
                                </Text>
                            );
                        case "training":
                            return (
                                <Text>{props?.rowData?.training?.name}</Text>
                            );
                        case "action":
                            return (
                                <HStack justify={"flex-end"} gap={3}>
                                    <AppOptionsBox
                                        options={actionOptions}
                                        data={props?.rowData}
                                        onClick={onActionClick}
                                    />
                                </HStack>
                            );
                    }
                },
            },
        },
    };

    return <KaTable {...kaTableProps} />;
};
